var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7E899E;}.a,.b{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 12,
    transform: "translate(32 32)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.03,
    transform: "translate(32 20)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/info-grey.1265da37e133c17b5ebf3ebb5919f24a.svg";
export { ForwardRef as ReactComponent };